(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var overlay = drawer.querySelector('.cart-drawer__overlay');
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    var itemsEl = drawer.querySelector('.cart-drawer__items');
    var emptyEl = drawer.querySelector('.cart-drawer__empty');
    var footerEl = drawer.querySelector('.cart-drawer__footer');
    var subtotalEl = drawer.querySelector('.cart-drawer__subtotal-price');
    var subtotalLabelEl = drawer.querySelector('.cart-drawer__subtotal-label');
    var shippingRowEl = drawer.querySelector('.cart-drawer__shipping-row');
    var rewardTextEl = drawer.querySelector('.cart-drawer__reward-text');
    var rewardFill = drawer.querySelector('.cart-drawer__reward-fill');
    var milestoneShipping = drawer.querySelector('.cart-drawer__reward-milestone--shipping');
    var milestoneGift = drawer.querySelector('.cart-drawer__reward-milestone--gift');

    var returnBar = drawer.querySelector('.cart-drawer__return-bar');
    var rewardEl = drawer.querySelector('.cart-drawer__reward');
    var upsellEl = drawer.querySelector('.cart-drawer__upsell');
    var giftEl = drawer.querySelector('.cart-drawer__gift');
    var blazeEl = drawer.querySelector('.cart-drawer__blaze');
    var discountRowEl = drawer.querySelector('.cart-drawer__discount-row');
    var discountCodeEl = drawer.querySelector('.cart-drawer__discount-label');
    var discountSavingEl = drawer.querySelector('.cart-drawer__discount-saving');
    var saleRowEl = drawer.querySelector('.cart-drawer__sale-row');
    var saleSavingEl = drawer.querySelector('.cart-drawer__sale-saving');
    var bundleRowEl = drawer.querySelector('.cart-drawer__bundle-row');
    var bundleSavingEl = drawer.querySelector('.cart-drawer__bundle-saving');
    var moneyFormat = drawer.getAttribute('data-money-format') || '\u20ac{{amount}}';
    // Let op: 0 is een geldige drempel (altijd gratis), dus geen || -fallback.
    var shippingAttr = drawer.getAttribute('data-shipping-threshold');
    var SHIPPING = parseInt(shippingAttr, 10);
    if (isNaN(SHIPPING)) SHIPPING = 10000;
    var GIFT = parseInt(drawer.getAttribute('data-gift-threshold')) || 10000;
    var promoHandles = (drawer.getAttribute('data-promo-handles') || '').split(',').filter(Boolean);
    var overshirtIds = (drawer.getAttribute('data-overshirt-product-ids') || '')
      .split(',')
      .filter(Boolean)
      .map(Number);
    var preorderIds = (drawer.getAttribute('data-preorder-product-ids') || '')
      .split(',')
      .filter(Boolean)
      .map(Number);
    var promoIds = [];

    // Haal product IDs op via de publieke collection-endpoint (geen Liquid 50-iteraties limiet)
    if (promoHandles.length > 0) {
      var remaining = promoHandles.length;
      promoHandles.forEach(function (handle) {
        fetch('/collections/' + handle + '/products.json?limit=250', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.products) {
              data.products.forEach(function (p) {
                if (promoIds.indexOf(p.id) === -1) promoIds.push(p.id);
              });
            }
          })
          .catch(function () {})
          .finally(function () {
            remaining--;
            if (remaining === 0 && drawer.getAttribute('aria-hidden') === 'false') fetchCart();
          });
      });
    }
    var giftEnabled = drawer.getAttribute('data-gift-enabled') === 'true';
    var giftProductIds = (drawer.getAttribute('data-gift-product-ids') || '').split(',').map(Number).filter(Boolean);
    var blazeProductIds = (drawer.getAttribute('data-blaze-product-ids') || '').split(',').map(Number).filter(Boolean);
    var shortsIds = [];
    var shortsHandle = drawer.getAttribute('data-shorts-handle');
    if (shortsHandle) {
      fetch('/collections/' + shortsHandle + '/products.json?limit=250', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.products) {
            data.products.forEach(function (p) {
              if (shortsIds.indexOf(p.id) === -1) shortsIds.push(p.id);
            });
          }
        })
        .catch(function () {})
        .finally(function () {
          if (drawer.getAttribute('aria-hidden') === 'false') fetchCart();
        });
    }
    var textBelow = drawer.getAttribute('data-text-below') || 'Nog {amount} voor gratis verzending.';
    var textShipping = drawer.getAttribute('data-text-shipping') || 'Gratis verzending! Nog {amount} voor een gratis Blaze T-Shirt.';
    var textAll = drawer.getAttribute('data-text-all') || 'Gratis verzending + gratis Blaze T-Shirt!';
    var textCodeNotCombinable = drawer.getAttribute('data-text-code-not-combinable') || 'Niet te combineren met deze actie';
    var textGiftOnly = drawer.getAttribute('data-text-gift-only') || 'Gratis Blaze T-Shirt! Nog {amount} voor gratis verzending.';
    var labelSubtotal = drawer.getAttribute('data-label-subtotal') || 'Subtotaal';
    var labelTotal = drawer.getAttribute('data-label-total') || 'Totaal';
    var textFree = drawer.getAttribute('data-text-free') || 'Gratis';
    var labelLess = drawer.getAttribute('data-label-less') || 'Minder';
    var labelMore = drawer.getAttribute('data-label-more') || 'Meer';
    var labelRemove = drawer.getAttribute('data-label-remove') || 'Verwijderen';
    var labelPromo = drawer.getAttribute('data-label-promo') || '2+1 GRATIS';
    var labelPreorder = drawer.getAttribute('data-label-preorder') || 'Pre-order';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount);
    }

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      fetchCart();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function parseBundleTiers(str) {
      if (!str) return [];
      return str.split(',').map(function (t) {
        var p = t.split(':');
        return { quantity: parseInt(p[0]), discount: parseInt(p[1]) };
      }).sort(function (a, b) { return b.quantity - a.quantity; });
    }

    function getBundleDiscount(tiers, qty) {
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].quantity) return tiers[i].discount;
      }
      return 0;
    }

    function fetchCart() {
      fetch('/cart.js')
        .then(function (res) {
          if (!res.ok) throw new Error('cart.js ' + res.status);
          return res.json();
        })
        .then(renderCart)
        .catch(function (err) { console.error('[cart-drawer] fetchCart failed:', err); });
    }

    function updateReward(totalCents, giftUnlocked) {
      var shippingReached = totalCents >= SHIPPING;
      // Een overshirt haalt het cadeau binnen los van het bedrag; de balk staat
      // dan vol, want er valt op dat punt niets meer te sparen.
      var giftReached = giftEnabled && (giftUnlocked || totalCents >= GIFT);

      var fillTarget = giftEnabled ? GIFT : SHIPPING;
      var pct = giftReached || fillTarget <= 0
        ? 100
        : Math.min(totalCents / fillTarget * 100, 100);
      rewardFill.style.width = pct + '%';

      if (milestoneShipping) milestoneShipping.classList.toggle('cart-drawer__reward-milestone--reached', shippingReached);
      if (milestoneGift) milestoneGift.classList.toggle('cart-drawer__reward-milestone--reached', giftReached);

      if (rewardTextEl) {
        if (giftReached && shippingReached) {
          rewardTextEl.innerHTML = textAll;
        } else if (giftReached) {
          // Cadeau al binnen via een overshirt, maar nog onder de verzenddrempel.
          rewardTextEl.innerHTML = textGiftOnly.replace('{amount}', formatMoney(SHIPPING - totalCents));
        } else if (shippingReached) {
          if (giftEnabled) {
            rewardTextEl.innerHTML = textShipping.replace('{amount}', formatMoney(GIFT - totalCents));
          } else {
            rewardTextEl.innerHTML = textAll;
          }
        } else {
          rewardTextEl.innerHTML = textBelow.replace('{amount}', formatMoney(SHIPPING - totalCents));
        }
      }
    }

    function renderCart(cart) {
      updateBadge(cart.item_count);

      var heeftOvershirt = overshirtIds.length > 0 && cart.items.some(function (item) {
        return item.quantity > 0 && overshirtIds.indexOf(item.product_id) !== -1;
      });

      updateReward(cart.total_price, heeftOvershirt);

      var isEmpty = cart.item_count === 0;
      var giftReached = giftEnabled && (heeftOvershirt || cart.total_price >= GIFT);
      var hasFreeItem = giftEnabled && cart.items.some(function (item) {
        return item.final_line_price === 0 && item.quantity > 0 && giftProductIds.indexOf(item.product_id) !== -1;
      });

      var shortsInCart = shortsIds.length > 0
        ? cart.items.reduce(function (sum, item) {
            return sum + (shortsIds.indexOf(item.product_id) !== -1 ? item.quantity : 0);
          }, 0)
        : 0;
      var hasFreeBlaze = cart.items.some(function (item) {
        return item.final_line_price === 0 && item.quantity > 0 && blazeProductIds.indexOf(item.product_id) !== -1;
      });
      var blazeReached;
      if (!hasFreeItem) {
        blazeReached = shortsInCart >= 2;
      } else {
        var shortsCartValue = shortsIds.length > 0
          ? cart.items.reduce(function (sum, item) {
              return sum + (shortsIds.indexOf(item.product_id) !== -1 ? item.final_line_price : 0);
            }, 0)
          : 0;
        var nonShortsTotal = cart.total_price - shortsCartValue;
        var gapToFill = Math.max(0, GIFT - nonShortsTotal);
        var avgShortPrice = shortsInCart > 0 ? shortsCartValue / shortsInCart : 0;
        var shortsNeededForGift = avgShortPrice > 0 ? Math.ceil(gapToFill / avgShortPrice) : 0;
        blazeReached = Math.max(0, shortsInCart - shortsNeededForGift) >= 2;
      }

      var giftVisible = !isEmpty && giftReached && !hasFreeItem;
      var blazeVisible = !isEmpty && blazeReached && !hasFreeBlaze && !giftVisible;
      var upsellVisible = !isEmpty && !giftVisible && !blazeVisible;

      if (returnBar) returnBar.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
      if (rewardEl) rewardEl.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
      if (upsellEl) upsellEl.setAttribute('aria-hidden', upsellVisible ? 'false' : 'true');
      if (giftEl) giftEl.setAttribute('aria-hidden', giftVisible ? 'false' : 'true');
      if (blazeEl) blazeEl.setAttribute('aria-hidden', blazeVisible ? 'false' : 'true');

      if (isEmpty) {
        itemsEl.innerHTML = '';
        emptyEl.setAttribute('aria-hidden', 'false');
        footerEl.setAttribute('aria-hidden', 'true');
        return;
      }

      emptyEl.setAttribute('aria-hidden', 'true');
      footerEl.setAttribute('aria-hidden', 'false');

      // Bundle savings: group by tier key, sum qty, find correct discount layer
      var bundleGroups = {};
      cart.items.forEach(function (item) {
        var ts = item.properties && item.properties['_bundle_tiers'];
        if (!ts) return;
        if (!bundleGroups[ts]) bundleGroups[ts] = { tiers: parseBundleTiers(ts), qty: 0 };
        bundleGroups[ts].qty += item.quantity;
      });

      function itemBundlePct(item) {
        var ts = item.properties && item.properties['_bundle_tiers'];
        if (ts && bundleGroups[ts]) return getBundleDiscount(bundleGroups[ts].tiers, bundleGroups[ts].qty);
        var fallback = item.properties && item.properties['_bundle_discount'] ? parseInt(item.properties['_bundle_discount']) : 0;
        return fallback;
      }

      var originalTotal = cart.items.reduce(function (sum, item) {
        return sum + item.original_line_price;
      }, 0);

      var totalBundleSavings = cart.items.reduce(function (sum, item) {
        var pct = itemBundlePct(item);
        return sum + (pct > 0 ? Math.round(item.original_line_price * pct / 100) : 0);
      }, 0);
      totalBundleSavings = Math.min(totalBundleSavings, originalTotal);

      var promoTotalCount = promoIds.length > 0
        ? cart.items.reduce(function (s, it) { return s + (promoIds.indexOf(it.product_id) !== -1 ? it.quantity : 0); }, 0)
        : 0;

      var totalSaleDiscount = cart.items.reduce(function (sum, item) {
        var ca = parseInt(item.properties && item.properties['_compare_at'] || '0');
        return sum + (ca > item.price ? (ca - item.price) * item.quantity : 0);
      }, 0);

      var totalPromoDiscount = promoTotalCount >= 3
        ? cart.items.reduce(function (sum, item) {
            if (promoIds.indexOf(item.product_id) === -1) return sum;
            var diff = item.original_line_price - item.final_line_price;
            return sum + (diff > 0 ? diff : 0);
          }, 0)
        : 0;

      // Korting uit een kortingscode krijgt een eigen regel met de code erbij.
      // Een code op productniveau (zoals Sweater30) zit ook in final_line_price,
      // dus die halen we hier uit de algemene kortingsregel, anders staat hij er twee keer.
      function codeDiscountOnItem(item) {
        return (item.line_level_discount_allocations || []).reduce(function (s, a) {
          return s + (a.discount_application && a.discount_application.type === 'discount_code' ? a.amount : 0);
        }, 0);
      }

      var codeDiscountTotal = cart.items.reduce(function (sum, item) {
        return sum + codeDiscountOnItem(item);
      }, 0) + (cart.cart_level_discount_applications || []).reduce(function (s, d) {
        return s + (d.type === 'discount_code' ? d.total_allocated_amount : 0);
      }, 0);

      var shopifyAutoDiscount = cart.items.reduce(function (sum, item) {
        var pct = itemBundlePct(item);
        if (pct > 0) return sum;
        if (promoTotalCount >= 3 && promoIds.indexOf(item.product_id) !== -1) return sum;
        var diff = item.original_line_price - item.final_line_price - codeDiscountOnItem(item);
        return sum + (diff > 0 ? diff : 0);
      }, 0);

      var totalDiscount = totalBundleSavings + totalSaleDiscount + totalPromoDiscount + shopifyAutoDiscount;
      if (saleRowEl) {
        saleRowEl.setAttribute('aria-hidden', totalDiscount > 0 ? 'false' : 'true');
        if (saleSavingEl) saleSavingEl.innerHTML = totalDiscount > 0 ? '-' + formatMoney(totalDiscount) : '';
      }

      var effectiveTotal = originalTotal - totalBundleSavings - totalPromoDiscount - shopifyAutoDiscount;
      // bundle row merged into sale/korting row

      // Een code telt pas als Shopify hem echt toepast. Een code die niet samen
      // mag met een andere actie (bijv. het gratis T-shirt) staat wel in
      // discount_codes, maar levert niets op; die tonen we met een melding.
      var enteredCodes = cart.discount_codes || [];
      var hasDiscount = codeDiscountTotal > 0;
      var rejectedCode = !hasDiscount && enteredCodes.length > 0 ? enteredCodes[0].code : '';
      if (discountRowEl) {
        discountRowEl.setAttribute('aria-hidden', (hasDiscount || rejectedCode) ? 'false' : 'true');
        discountRowEl.classList.toggle('cart-drawer__discount-row--rejected', !!rejectedCode);
        if (hasDiscount) {
          var applied = enteredCodes.filter(function (c) { return c.applicable; })[0] || enteredCodes[0];
          discountCodeEl.textContent = applied ? applied.code : '';
          discountSavingEl.innerHTML = '-' + formatMoney(codeDiscountTotal);
        } else if (rejectedCode) {
          discountCodeEl.textContent = rejectedCode;
          discountSavingEl.textContent = textCodeNotCombinable;
        }
      }
      subtotalEl.innerHTML = hasDiscount
        ? '<s>' + formatMoney(cart.original_total_price) + '</s>' + formatMoney(cart.total_price)
        : formatMoney(effectiveTotal);

      var freeShipping = effectiveTotal >= SHIPPING;
      if (shippingRowEl) {
        shippingRowEl.setAttribute('aria-hidden', freeShipping ? 'false' : 'true');
      }
      if (subtotalLabelEl) {
        subtotalLabelEl.textContent = freeShipping ? labelTotal : labelSubtotal;
      }

      // Codekorting op orderniveau wordt naar verhouding over de regels verdeeld.
      var cartLevelCodeDiscount = (cart.cart_level_discount_applications || []).reduce(function (s, d) {
        return s + (d.type === 'discount_code' ? d.total_allocated_amount : 0);
      }, 0);
      var cartCodeRatio = cart.original_total_price > 0 ? cartLevelCodeDiscount / cart.original_total_price : 0;

      itemsEl.innerHTML = cart.items.filter(function (item) { return item.quantity > 0; }).map(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.\w+)$/, '_120x160$1') + '" alt="" class="cart-item__image" loading="lazy">'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
          : '';
        var line = i + 1;
        var originalPrice = item.original_line_price;
        var bundlePct = itemBundlePct(item);
        var bundleLabelProp = item.properties && item.properties['_bundle_label'] ? item.properties['_bundle_label'] : '';
        var bundleBadgeText = bundlePct > 0 ? (bundleLabelProp || '-' + bundlePct + '%') : '';
        var bundleBadge = bundleBadgeText ? '<span class="cart-item__bundle-badge">' + bundleBadgeText + '</span>' : '';
        var isPromoItem = promoIds.length > 0 && promoIds.indexOf(item.product_id) !== -1;
        var isPromoActive = isPromoItem && promoTotalCount >= 3;
        var promoBadge = isPromoActive
          ? '<span class="cart-item__promo-badge">' + labelPromo + '</span>'
          : '';
        var preorderBadge = preorderIds.indexOf(item.product_id) !== -1
          ? '<span class="cart-item__preorder-badge">' + labelPreorder + '</span>'
          : '';
        var itemCodeDiscount = codeDiscountOnItem(item) + Math.round(originalPrice * cartCodeRatio);
        var discountedPrice = bundlePct > 0
          ? Math.round(originalPrice * (1 - bundlePct / 100))
          : originalPrice - itemCodeDiscount;
        var compareAtProp = parseInt(item.properties && item.properties['_compare_at'] || '0');
        var compareLinePrice = (compareAtProp > 0 && compareAtProp > item.price)
          ? compareAtProp * item.quantity
          : 0;
        var isOutfitItem = item.properties && item.properties['_outfit'] === '1';
        var autoDiscount = bundlePct === 0 && !isPromoActive && item.original_line_price > item.final_line_price && item.final_line_price > 0;
        var autoDiscountTitle = isOutfitItem && autoDiscount && item.discounts && item.discounts.length > 0 ? item.discounts[0].title : '';
        var autoDiscountBadge = autoDiscountTitle ? '<span class="cart-item__outfit-badge">' + autoDiscountTitle + '</span>' : '';
        var priceHtml = item.final_line_price === 0
          ? '<span class="cart-item__price cart-item__price--free">' + textFree + '</span>'
          : (bundlePct > 0 || itemCodeDiscount > 0
              ? '<span class="cart-item__price"><s>' + formatMoney(originalPrice) + '</s> <span class="cart-item__price-discount">' + formatMoney(discountedPrice) + '</span></span>'
              : (compareLinePrice > 0
                  ? '<span class="cart-item__price"><s>' + formatMoney(compareLinePrice) + '</s> <span class="cart-item__price-discount">' + formatMoney(item.final_line_price) + '</span></span>'
                  : (isPromoActive && item.original_line_price > item.final_line_price
                      ? '<span class="cart-item__price"><s>' + formatMoney(item.original_line_price) + '</s> <span class="cart-item__price-discount">' + formatMoney(item.final_line_price) + '</span></span>'
                      : (autoDiscount
                          ? '<span class="cart-item__price"><s>' + formatMoney(item.original_line_price) + '</s> <span class="cart-item__price-discount">' + formatMoney(item.final_line_price) + '</span></span>'
                          : '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>'))));
        return '<div class="cart-item" data-line="' + line + '">'
          + '<a href="' + item.url + '" class="cart-item__image-link">' + img + '</a>'
          + '<div class="cart-item__info">'
          + '<a href="' + item.url + '" class="cart-item__title">' + ((item.properties && item.properties['_display_title']) || item.product_title) + '</a>'
          + preorderBadge
          + promoBadge
          + bundleBadge
          + autoDiscountBadge
          + variant
          + '<div class="cart-item__bottom">'
          + '<div class="cart-item__qty">'
          + '<button class="cart-item__qty-btn" data-line="' + line + '" data-action="decrease" aria-label="' + labelLess + '">&#8722;</button>'
          + '<span class="cart-item__qty-value">' + item.quantity + '</span>'
          + '<button class="cart-item__qty-btn" data-line="' + line + '" data-action="increase" aria-label="' + labelMore + '">+</button>'
          + '</div>'
          + priceHtml
          + '</div>'
          + '</div>'
          + '<button class="cart-item__remove" data-line="' + line + '" aria-label="' + labelRemove + '">'
          + '<svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
          + '</button>'
          + '</div>';
      }).join('');
    }

    // --- Request queue: all cart mutations run serially to prevent Cloudflare bot triggers ---
    var queueBusy = false;
    var queuePending = [];

    function drainQueue() {
      if (queueBusy || queuePending.length === 0) return;
      queueBusy = true;
      drawer.classList.add('cart-drawer--loading');
      var job = queuePending.shift();
      job.fn()
        .then(function (data) { job.resolve(data); })
        .catch(function (err) { job.reject(err); })
        .finally(function () {
          queueBusy = false;
          drawer.classList.remove('cart-drawer--loading');
          drainQueue();
        });
    }

    function enqueueRequest(fn) {
      return new Promise(function (resolve, reject) {
        queuePending.push({ fn: fn, resolve: resolve, reject: reject });
        drainQueue();
      });
    }

    // Debounce state: rapid +/- clicks are coalesced into one request per line
    var qtyTimers = {};
    var qtyTargets = {};

    function changeQty(line, qty) {
      var row = itemsEl ? itemsEl.querySelector('.cart-item[data-line="' + line + '"]') : null;
      if (row) {
        var valEl = row.querySelector('.cart-item__qty-value');
        if (valEl) valEl.textContent = Math.max(0, qty);
      }

      qtyTargets[line] = qty;
      clearTimeout(qtyTimers[line]);
      qtyTimers[line] = setTimeout(function () {
        var target = qtyTargets[line];
        delete qtyTargets[line];
        delete qtyTimers[line];
        enqueueRequest(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ line: line, quantity: target })
          }).then(function (res) { return res.json(); });
        }).then(function (cart) {
          // Het antwoord van change.js rekent kortingscodes nog niet opnieuw door
          // (een code die door een andere actie geweigerd werd, blijft geweigerd).
          // Eerst direct tekenen voor de snelheid, daarna met verse cart.js.
          renderCart(cart);
          fetchCart();
        }).catch(function () { fetchCart(); });
      }, 350);
    }

    function addToCart(variantId, btn) {
      if (btn) btn.disabled = true;
      enqueueRequest(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(function (res) { return res.json(); });
      }).then(function (item) {
        fetchCart();
        window.mdq = window.mdq || [];
        window.mdq.push(['track', 'AddToCart', {
          content_ids: [String(item.product_id)],
          content_name: item.product_title,
          currency: 'EUR',
          value: item.price / 100
        }]);
      }).catch(function (err) { console.error('[cart-drawer] addToCart failed:', err); fetchCart(); })
        .finally(function () { if (btn) btn.disabled = false; });
    }

    function updateBadge(count) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = count;
        el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      });
    }

    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) { changeQty(parseInt(removeBtn.getAttribute('data-line')), 0); return; }

      var qtyBtn = e.target.closest('.cart-item__qty-btn');
      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute('data-line'));
        var action = qtyBtn.getAttribute('data-action');
        var qtyEl = qtyBtn.closest('.cart-item__qty').querySelector('.cart-item__qty-value');
        changeQty(line, Math.max(0, parseInt(qtyEl.textContent) + (action === 'increase' ? 1 : -1)));
        return;
      }

      var giftAddBtn = e.target.closest('[data-gift-add]');
      if (giftAddBtn) {
        var giftCard = giftAddBtn.closest('.cart-upsell__card');
        var giftSelect = giftCard ? giftCard.querySelector('[data-gift-select]') : null;
        var giftVariantId = giftSelect ? giftSelect.value : giftAddBtn.getAttribute('data-variant-id');
        addToCart(giftVariantId, giftAddBtn);
        return;
      }

      var blazeAddBtn = e.target.closest('[data-blaze-add]');
      if (blazeAddBtn) {
        var blazeCard = blazeAddBtn.closest('.cart-upsell__card');
        var blazeSelect = blazeCard ? blazeCard.querySelector('[data-blaze-select]') : null;
        var blazeVariantId = blazeSelect ? blazeSelect.value : blazeAddBtn.getAttribute('data-variant-id');
        addToCart(blazeVariantId, blazeAddBtn);
        return;
      }

      var upsellBtn = e.target.closest('.cart-upsell__add');
      if (upsellBtn) {
        var upsellCard = upsellBtn.closest('.cart-upsell__card');
        var upsellSelect = upsellCard ? upsellCard.querySelector('[data-upsell-select]') : null;
        var upsellVariantId = upsellSelect ? upsellSelect.value : upsellBtn.getAttribute('data-variant-id');
        addToCart(upsellVariantId, upsellBtn);
        return;
      }
    });

    var checkoutBtn = drawer.querySelector('.cart-drawer__checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        window.location.href = checkoutBtn.getAttribute('data-checkout-url');
      });
    }

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:refresh', fetchCart);

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.cart-drawer-trigger');
      if (trigger) { e.preventDefault(); openDrawer(); }
    });

    // ===== Upsell slider =====
    var upsellTrackWrap = drawer.querySelector('.cart-upsell__track-wrap');
    var upsellTrack = drawer.querySelector('.cart-upsell__track');
    var upsellPrev = drawer.querySelector('.cart-upsell__arrow--prev');
    var upsellNext = drawer.querySelector('.cart-upsell__arrow--next');

    if (upsellTrack) {
      var upsellCards = Array.from(upsellTrack.querySelectorAll('.cart-upsell__card'));
      var upsellTotal = upsellCards.length;
      var upsellCurrent = 0;

      function upsellGetVisible() {
        if (!upsellTrackWrap || !upsellCards[0]) return 1;
        return Math.round(upsellTrackWrap.offsetWidth / (upsellCards[0].offsetWidth + 12));
      }

      function upsellGoTo(idx) {
        var visible = upsellGetVisible();
        upsellCurrent = Math.max(0, Math.min(idx, upsellTotal - visible));
        var cardWidth = upsellCards[0] ? upsellCards[0].offsetWidth + 12 : 0;
        upsellTrack.style.transform = 'translateX(-' + (upsellCurrent * cardWidth) + 'px)';
        if (upsellPrev) upsellPrev.disabled = upsellCurrent === 0;
        if (upsellNext) upsellNext.disabled = upsellCurrent >= upsellTotal - visible;
      }

      if (upsellPrev) upsellPrev.addEventListener('click', function () { upsellGoTo(upsellCurrent - 1); });
      if (upsellNext) upsellNext.addEventListener('click', function () { upsellGoTo(upsellCurrent + 1); });
      upsellGoTo(0);

      // Touch swipe
      var upsellTouchStartX = 0;
      upsellTrack.addEventListener('touchstart', function (e) { upsellTouchStartX = e.touches[0].clientX; }, { passive: true });
      upsellTrack.addEventListener('touchend', function (e) {
        var delta = upsellTouchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 40) upsellGoTo(upsellCurrent + (delta > 0 ? 1 : -1));
      }, { passive: true });

      // Re-init when drawer opens so offsetWidth is correct
      document.addEventListener('cart:open', function () {
        setTimeout(function () { upsellGoTo(upsellCurrent); }, 50);
      });
    }

    // ===== Gift slider =====
    var giftTrackWrap = giftEl ? giftEl.querySelector('.cart-gift__track-wrap') : null;
    var giftTrack = giftEl ? giftEl.querySelector('.cart-gift__track') : null;
    var giftPrev = giftEl ? giftEl.querySelector('.cart-gift__arrow--prev') : null;
    var giftNext = giftEl ? giftEl.querySelector('.cart-gift__arrow--next') : null;

    if (giftTrack) {
      var giftCards = Array.from(giftTrack.querySelectorAll('.cart-upsell__card'));
      var giftTotal = giftCards.length;
      var giftCurrent = 0;

      function giftGetVisible() {
        if (!giftTrackWrap || !giftCards[0]) return 1;
        return Math.round(giftTrackWrap.offsetWidth / (giftCards[0].offsetWidth + 12));
      }

      function giftGoTo(idx) {
        var visible = giftGetVisible();
        giftCurrent = Math.max(0, Math.min(idx, giftTotal - visible));
        var cardWidth = giftCards[0] ? giftCards[0].offsetWidth + 12 : 0;
        giftTrack.style.transform = 'translateX(-' + (giftCurrent * cardWidth) + 'px)';
        if (giftPrev) giftPrev.disabled = giftCurrent === 0;
        if (giftNext) giftNext.disabled = giftCurrent >= giftTotal - visible;
      }

      if (giftPrev) giftPrev.addEventListener('click', function () { giftGoTo(giftCurrent - 1); });
      if (giftNext) giftNext.addEventListener('click', function () { giftGoTo(giftCurrent + 1); });
      giftGoTo(0);

      // Touch swipe
      var giftTouchStartX = 0;
      giftTrack.addEventListener('touchstart', function (e) { giftTouchStartX = e.touches[0].clientX; }, { passive: true });
      giftTrack.addEventListener('touchend', function (e) {
        var delta = giftTouchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 40) giftGoTo(giftCurrent + (delta > 0 ? 1 : -1));
      }, { passive: true });

      document.addEventListener('cart:open', function () {
        setTimeout(function () { giftGoTo(giftCurrent); }, 50);
      });
    }

    // ===== Blaze slider =====
    var blazeTrackWrap = blazeEl ? blazeEl.querySelector('.cart-gift__track-wrap') : null;
    var blazeTrack = blazeEl ? blazeEl.querySelector('.cart-blaze__track') : null;
    var blazePrev = blazeEl ? blazeEl.querySelector('.cart-blaze__arrow--prev') : null;
    var blazeNext = blazeEl ? blazeEl.querySelector('.cart-blaze__arrow--next') : null;

    if (blazeTrack) {
      var blazeCards = Array.from(blazeTrack.querySelectorAll('.cart-upsell__card'));
      var blazeTotal = blazeCards.length;
      var blazeCurrent = 0;

      function blazeGetVisible() {
        if (!blazeTrackWrap || !blazeCards[0]) return 1;
        return Math.round(blazeTrackWrap.offsetWidth / (blazeCards[0].offsetWidth + 12));
      }

      function blazeGoTo(idx) {
        var visible = blazeGetVisible();
        blazeCurrent = Math.max(0, Math.min(idx, blazeTotal - visible));
        var cardWidth = blazeCards[0] ? blazeCards[0].offsetWidth + 12 : 0;
        blazeTrack.style.transform = 'translateX(-' + (blazeCurrent * cardWidth) + 'px)';
        if (blazePrev) blazePrev.disabled = blazeCurrent === 0;
        if (blazeNext) blazeNext.disabled = blazeCurrent >= blazeTotal - visible;
      }

      if (blazePrev) blazePrev.addEventListener('click', function () { blazeGoTo(blazeCurrent - 1); });
      if (blazeNext) blazeNext.addEventListener('click', function () { blazeGoTo(blazeCurrent + 1); });
      blazeGoTo(0);

      var blazeTouchStartX = 0;
      blazeTrack.addEventListener('touchstart', function (e) { blazeTouchStartX = e.touches[0].clientX; }, { passive: true });
      blazeTrack.addEventListener('touchend', function (e) {
        var delta = blazeTouchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 40) blazeGoTo(blazeCurrent + (delta > 0 ? 1 : -1));
      }, { passive: true });

      document.addEventListener('cart:open', function () {
        setTimeout(function () { blazeGoTo(blazeCurrent); }, 50);
      });
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('.lang-select[open]').forEach(function (el) {
      if (!el.contains(event.target)) el.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lang-select[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // ===== Hover-foto's ophalen zodra de muis het raster nadert =====
    // De foto's staan zonder src in de HTML, zodat ze niet meeladen bij het
    // openen van de pagina. Zodra de muis ergens in een sectie met kaarten
    // komt, halen we de hover-foto's op van de kaarten die in beeld staan —
    // dus vóórdat de muis een kaart bereikt, anders hapert de eerste wissel.
    // Op een touchscreen gebeurt dit nooit, en onder 769px toont de CSS de
    // hover-foto sowieso niet.
    var laatstePass = 0;

    function laadHoverFoto(media) {
      var img = media.querySelector('.product-card__img--hover[data-hover-src]');
      if (!img) return;
      if (img.dataset.hoverSrcset) img.srcset = img.dataset.hoverSrcset;
      img.src = img.dataset.hoverSrc;
      img.removeAttribute('data-hover-src');
      img.removeAttribute('data-hover-srcset');
    }

    function staatInBeeld(el) {
      var r = el.getBoundingClientRect();
      // Ruime marge, zodat een kaart net onder de vouw ook alvast klaarstaat.
      return r.bottom > -200 && r.top < window.innerHeight + 200;
    }

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!window.matchMedia('(min-width: 769px)').matches) return;

      // Vangnet: een kaart die pas later in beeld kwam, laadt alsnog bij hover.
      var media = e.target.closest('.product-card__media.has-hover-image');
      if (media) laadHoverFoto(media);

      // En de vooruitloper: alles wat in deze sectie in beeld staat.
      var nu = Date.now();
      if (nu - laatstePass < 400) return;

      var sectie = e.target.closest('.shopify-section');
      if (!sectie) return;

      var wachtenden = sectie.querySelectorAll(
        '.product-card__media.has-hover-image .product-card__img--hover[data-hover-src]'
      );
      if (!wachtenden.length) return;

      laatstePass = nu;
      wachtenden.forEach(function (img) {
        var kaart = img.closest('.product-card__media');
        if (staatInBeeld(kaart)) laadHoverFoto(kaart);
      });
    });
  })();

  (function () {
    var modal = null;
    var currentForm = null;

    // Vertalingen staan als data-attributen op het notify-formulier, want in
    // javascript-blokken wordt geen Liquid uitgevoerd.
    function t(name, fallback) {
      var src = currentForm || document.querySelector('.product-card__notify-form');
      var value = src && src.getAttribute('data-text-' + name);
      return value || fallback;
    }

    function getModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'pc-notify-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'pc-notify-title');
      var description = t('description', 'Laat je e-mailadres achter en we sturen je een bericht zodra [product] (maat [size]) weer beschikbaar is.')
        .replace('[product]', '<strong class="pc-notify-modal__product"></strong>')
        .replace('[size]', '<span class="pc-notify-modal__variant"></span>');

      modal.innerHTML =
        '<div class="pc-notify-modal__backdrop"></div>' +
        '<div class="pc-notify-modal__dialog">' +
          '<button class="pc-notify-modal__close" aria-label="' + t('close', 'Sluiten') + '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<h2 class="pc-notify-modal__title" id="pc-notify-title">' + t('title', 'Melding ontvangen') + '</h2>' +
          '<p class="pc-notify-modal__desc">' + description + '</p>' +
          '<input type="email" class="pc-notify-modal__email" placeholder="' + t('placeholder', 'jouw@email.nl') + '" autocomplete="email">' +
          '<button class="pc-notify-modal__submit">' + t('submit', 'Stuur me een melding') + '</button>' +
          '<p class="pc-notify-modal__success" hidden>' + t('success', 'Bedankt! We laten je weten zodra het product weer op voorraad is.') + '</p>' +
        '</div>';
      document.body.appendChild(modal);
      modal.querySelector('.pc-notify-modal__backdrop').addEventListener('click', closeModal);
      modal.querySelector('.pc-notify-modal__close').addEventListener('click', closeModal);
      modal.querySelector('.pc-notify-modal__submit').addEventListener('click', submitNotify);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
      return modal;
    }

    function openModal(productTitle, variantOption, form) {
      var m = getModal();
      currentForm = form;
      m.querySelector('.pc-notify-modal__product').textContent = productTitle;
      m.querySelector('.pc-notify-modal__variant').textContent = variantOption;
      m.querySelector('.pc-notify-modal__email').value = '';
      m.querySelector('.pc-notify-modal__email').hidden = false;
      m.querySelector('.pc-notify-modal__submit').hidden = false;
      m.querySelector('.pc-notify-modal__desc').hidden = false;
      m.querySelector('.pc-notify-modal__success').hidden = true;
      m.classList.add('pc-notify-modal--open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { m.querySelector('.pc-notify-modal__email').focus(); }, 50);
    }

    function closeModal() {
      if (modal) {
        modal.classList.remove('pc-notify-modal--open');
        document.body.style.overflow = '';
      }
      currentForm = null;
    }

    function submitNotify() {
      if (!currentForm) return;
      var m = getModal();
      var emailInput = m.querySelector('.pc-notify-modal__email');
      var submitBtn = m.querySelector('.pc-notify-modal__submit');
      var email = emailInput.value.trim();
      if (!email || !emailInput.validity.valid) { emailInput.focus(); return; }

      var productTitle = m.querySelector('.pc-notify-modal__product').textContent;
      var variantOption = m.querySelector('.pc-notify-modal__variant').textContent;
      currentForm.querySelector('.pc-notify__email').value = email;
      currentForm.querySelector('.pc-notify__subject').value = t('mail-subject', 'Melding aangevraagd: [product] – maat [size]')
        .replace('[product]', productTitle)
        .replace('[size]', variantOption);
      currentForm.querySelector('.pc-notify__body').value = t('mail-body', 'Stuur een melding wanneer [product] in maat [size] weer beschikbaar is.')
        .replace('[product]', productTitle)
        .replace('[size]', variantOption);

      submitBtn.disabled = true;
      fetch(currentForm.action, { method: 'POST', body: new FormData(currentForm) })
        .then(function (res) {
          if (!res.ok) throw new Error();
          submitBtn.disabled = false;
          emailInput.hidden = true;
          submitBtn.hidden = true;
          m.querySelector('.pc-notify-modal__desc').hidden = true;
          m.querySelector('.pc-notify-modal__success').hidden = false;
          setTimeout(closeModal, 2500);
        })
        .catch(function () {
          submitBtn.disabled = false;
          currentForm.submit();
        });
    }

    document.addEventListener('click', function (e) {
      var unavailBtn = e.target.closest('.product-card__size--unavailable');
      if (unavailBtn) {
        var card = unavailBtn.closest('.product-card');
        var form = card.querySelector('.product-card__notify-form');
        openModal(unavailBtn.dataset.productTitle, unavailBtn.dataset.variantOption, form);
        return;
      }

      var btn = e.target.closest('.product-card__size[data-variant-id]');
      if (!btn || btn.disabled) return;

      var item = { id: Number(btn.dataset.variantId), quantity: 1 };
      var compareAt = parseInt(btn.dataset.compareAt || '0');
      var props = {};
      if (compareAt > 0) props['_compare_at'] = String(compareAt);
      if (btn.dataset.outfit) props['_outfit'] = '1';
      if (Object.keys(props).length > 0) item.properties = props;
      window.CartQ.add(item, btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
